import { Vue } from 'vue-property-decorator';

// 补充资料表单元素标准属性
export interface InfoComplementField extends Vue {
  onValidator: () => boolean | Promise<boolean>;
  changeOptions?: (
    propValue: string | number,
    ) => void;
}

/** 自营b用户需要做处理的职业信息类型 */
export enum ProfessionType {
  /** 生产、运输设备操作人员及有关人员 */
  TRANSPORT = 6,
  /** 农、林、牧、渔水利生产人员 */
  AGRICULTURE = 5
}

// 自营b- 提现补充资料 职业为“生产、运输设备操作人员及有关人员”，则行业选项剔除“批发和零售业”、
// “住宿和餐饮业”、“金融业”、“租赁和商务服务业”、“教育”、“公共管理”、“社会保障和社会组织”、“国际组织”
export const specArrCode = [
  101,
  102,
  103,
  104,
  105,
  107,
  109,
  111,
  113,
  114,
  115,
  117,
  118,
  120,
];
